import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { IFunding } from '@publishing-engine/domain/models';
import { Badge, Table } from '@morressier/alembic';

type IProps = {
  value: IFunding[];
};

export const FundingDisplay: React.FC<IProps> = ({ value }) => (
  <Flex flexDirection={'column'}>
    {
      <Table>
        <Table.Body sx={{ borderTop: 'none' }}>
          {value?.map(funding => (
            <Table.Row key={funding.grantNumber} gap={4} alignItems="baseline">
              <Table.RowCell flex="1" textStyle="headingItem" textAlign="left">
                <Flex flex={1} textStyle="headingItem">
                  {funding.fundingBody}
                </Flex>
              </Table.RowCell>
              <Table.RowCell flex="1" textStyle="headingItem" textAlign="left">
                <Flex flex={2} gap={2} alignItems="flex-start" flexWrap="wrap">
                  {funding.grantNumber.split(',').map((value, index) => (
                    <Flex key={index}>
                      <Badge>
                        <Text textStyle="headingItem">{value}</Text>
                      </Badge>
                    </Flex>
                  ))}
                </Flex>
              </Table.RowCell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    }
  </Flex>
);
